import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import moment from 'moment';
import { BarnyardIcon } from 'barnyard/icons';
import AlertItem from './AlertItem';
import CorporateLinkItemTable from './CorporateLinkItemTable';


const NoGLCodeAlert = ({ alert, ...other }) => (
  <AlertItem
    alert={alert}
    date={moment(alert.date).format('MMMM YYYY')}
    icon={<BarnyardIcon icon={['fa', 'times']} className='DiscussCard__replyIcon' />}
    title={(
      <div>
        {' '} An {' '}
        <Link to='/corporate/settings/itemlinks'>
          item link
        </Link>
        {' '} was created for an item with no GL code
      </div>
    )}
    content={(
      <CorporateLinkItemTable
        includeExport={true}
        items={alert.value.items}
      />
    )}
    {...other}
  />
);

NoGLCodeAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default NoGLCodeAlert;
